import { ChangeEvent } from "react";

import { Box, Checkbox, FormControlLabel } from "@mui/material";
import { InputLabel, Typography } from "components";
import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
  PathValue,
  useFormContext,
} from "react-hook-form";

const CheckboxHookForm = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  label,
  disabled,
  subTitle,
  required,
}: Omit<ControllerProps<TFieldValues, TName>, "control" | "render"> & {
  label: string;
  subTitle?: string;
  required?: boolean;
}) => {
  const { control } = useFormContext<TFieldValues>();
  const parseValue = (value: unknown): boolean => {
    if (typeof value === "string") {
      return value === "true" || value === "1";
    }
    if (typeof value === "number") {
      return value === 1;
    }
    return Boolean(value);
  };
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, onChange, value } }) => (
        <FormControlLabel
          control={
            <Checkbox
              disableRipple
              size="small"
              inputRef={ref}
              checked={parseValue(value)}
              name={name}
              id={name}
              onChange={(_e, checked) =>
                onChange(
                  checked as unknown as
                    | PathValue<TFieldValues, TName>
                    | ChangeEvent<Element>
                )
              }
              disabled={disabled}
            />
          }
          label={
            <Box marginLeft="5.5px">
              <InputLabel
                mb="0px"
                sx={{ cursor: "pointer" }}
                htmlFor={name}
                required={required}
              >
                {label}
              </InputLabel>
              <Typography type="TextXS" color="#475467">
                {subTitle || ""}
              </Typography>
            </Box>
          }
        />
      )}
    />
  );
};

export default CheckboxHookForm;
